import { getHeaderNavLinks } from "@/common/AppHeader/constants";
import { MenuListItem } from "../MenuListItem";
import { UserInfo } from "../UserInfo";
import { HeaderMobileControlButtons } from "../HeaderMobileControlButtons";
import { navLinkIcons } from "../../../constants";
import styles from "../styles.module.scss";

export const MenuList = () => {
  const headerNavLinks = getHeaderNavLinks();
  return (
    <div className={styles.container}>
      <UserInfo />
      {headerNavLinks.map(({ path, title }, index) => (
        <MenuListItem key={index} to={path} title={title} icon={navLinkIcons[index]} />
      ))}
      <HeaderMobileControlButtons />
    </div>
  );
};
